export default "__VITE_ASSET__6UxpSwDH__"